// import { useEffect, useState } from "react";

// /**
//  * TabToggle — Reusable icon-tab switcher
//  *
//  * Props:
//  *   items        – Array of { id, icon: ReactNode, label?: string }
//  *   defaultValue – id of the initially active tab (defaults to first item)
//  *   onChange     – (id) => void  called whenever the active tab changes
//  *   className    – extra class names for the wrapper
//  */
// export default function TabToggle({
//   items = [],
//   defaultValue,
//   onChange,
//   className = "",
//   selected,
// }) {
//   const [active, setActive] = useState(defaultValue ?? items[0]?.id);

//   function handleSelect(id) {
//     setActive(id);
//     onChange?.(id);
//   }

//   useEffect(() => {
//     if (selected) {
//       setActive(selected);
//     }
//   }, [selected]);

//   return (
//     <>
//       <style>{`
//         .tab-toggle-root {
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           padding: 6px 8px;
//           background: #ffffff;
//           border: 1px solid #ededed;
//           border-radius: 4px;
//           width: fit-content;
//         }

//         .tab-toggle-btn {
//           position: relative;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           padding: 5px 7px;
//           border: none;
//           border-radius: 3px;
//           background: transparent;
//           cursor: pointer;
//           color: #9ea3b0;
//           transition: color 0.18s ease, background 0.18s ease;
//           outline: none;
//         }

//         .tab-toggle-btn:focus-visible {
//           box-shadow: 0 0 0 2px #c4b8f0;
//         }

//         /* active pill */
//         .tab-toggle-btn[data-active="true"] {
//           background: #e8e3f8;
//           color: #1e2233;
//         }

//         /* hover on inactive */
//         .tab-toggle-btn[data-active="false"]:hover {
//           background: #f5f5f5;
//           color: #1e2233;
//         }

//         .tab-toggle-btn svg {
//           display: block;
//           width: 18px;
//           height: 18px;
//         }

//         /* optional text label */
//         .tab-toggle-label {
//           font-family: "DM Sans", sans-serif;
//           font-size: 13px;
//           font-weight: 500;
//           line-height: 1;
//           margin-left: 5px;
//         }
//       `}</style>

//       <div className={`tab-toggle-root ${className}`} role="tablist">
//         {items.map(({ id, icon, label }) => (
//           <button
//             key={id}
//             role="tab"
//             aria-selected={active === id}
//             data-active={active === id}
//             className="tab-toggle-btn"
//             onClick={() => handleSelect(id)}
//             title={label}
//           >
//             {icon}
//             {label && <span className="tab-toggle-label">{label}</span>}
//           </button>
//         ))}
//       </div>
//     </>
//   );
// }


// import { useState } from "react";

/**
 * TabToggle — Reusable icon-tab switcher with Material Icons
 *
 * Props:
 *   items        – Array of {
 *                    id: string,
 *                    activeIcon: string,    // Material Icon name for active state
 *                    inactiveIcon: string,  // Material Icon name for inactive state
 *                    label?: string
 *                  }
 *   defaultValue – id of the initially active tab
 *   onChange     – (id) => void
 *   className    – extra class names for the wrapper
 *
 * Usage:
 *   <TabToggle
 *     items={[
 *       { id: "grid", activeIcon: "grid_view",   inactiveIcon: "grid_view" },
 *       { id: "list", activeIcon: "view_list",   inactiveIcon: "list" },
 *     ]}
 *     defaultValue="grid"
 *     onChange={(id) => console.log(id)}
 *   />
 *
 * Material Icons variants supported via fontVariant prop:
 *   "outlined" | "rounded" | "sharp" | "two-tone" | "" (filled, default)
 */
// export default function TabToggle({
//   items = [],
//   defaultValue,
//   onChange,
//   fontVariant = "outlined",  // "outlined" | "rounded" | "sharp" | "two-tone" | ""
//   className = "",
// }) {
//   const [active, setActive] = useState(defaultValue ?? items[0]?.id);

//   const fontClass = fontVariant
//     ? `material-icons-${fontVariant}`
//     : "material-icons";

//   function handleSelect(id) {
//     setActive(id);
//     onChange?.(id);
//   }

//   return (
//     <>
//       <link
//         href="https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Round|Material+Icons+Sharp|Material+Icons+Two+Tone"
//         rel="stylesheet"
//       />
//       <style>{`
//         .tab-toggle-root {
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           padding: 6px 8px;
//           background: #ffffff;
//           border: 1px solid #ededed;
//           border-radius: 4px;
//           width: fit-content;
//         }

//         .tab-toggle-btn {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//           padding: 1px 4px 2px 4px;
//           border: none;
//           border-radius: 3px;
//           background: transparent;
//           cursor: pointer;
//           color: #9ea3b0;
//           transition: color 0.18s ease, background 0.18s ease;
//           outline: none;
//         }

//         .tab-toggle-btn:focus-visible {
//           box-shadow: 0 0 0 2px #c4b8f0;
//         }

//         .tab-toggle-btn[data-active="true"] {
//           background: #e8e3f8;
//           color: #1e2233;
//         }

//         .tab-toggle-btn[data-active="false"]:hover {
//           background: #f5f5f5;
//           color: #1e2233;
//         }

//         .tab-toggle-icon {
//      y
//         }

//         .tab-toggle-label {
//           font-family: "DM Sans", sans-serif;
//           font-size: 13px;
//           font-weight: 500;
//           line-height: 1;
//         }
//       `}</style>

//       <div className={`tab-toggle-root ${className}`} role="tablist">
//         {items.map(({ id, activeIcon, inactiveIcon, label }) => {
//           const isActive = active === id;
//           return (
//             <button
//               key={id}
//               role="tab"
//               aria-selected={isActive}
//               data-active={isActive}
//               className="tab-toggle-btn"
//               onClick={() => handleSelect(id)}
//               title={label ?? id}
//             >
//               <span className={`tab-toggle-icon ${fontClass}`} aria-hidden="true">
//                 {isActive ? activeIcon : inactiveIcon}
//               </span>
//               {label && <span className="tab-toggle-label">{label}</span>}
//             </button>
//           );
//         })}
//       </div>
//     </>
//   );
// }
import { useState, useEffect } from "react";

export default function TabToggle({
  items = [],
  defaultValue,
  selected,
  onChange,
  className = "",
}) {
  const [active, setActive] = useState(
    selected ?? defaultValue ?? items[0]?.id
  );

  useEffect(() => {
    if (selected !== undefined) {
      setActive(selected);
    }
  }, [selected]);

  function handleSelect(id) {
    setActive(id);
    onChange?.(id);
  }

  return (
    <>
      <style>{`
        .tab-toggle-root {
          display:inline-flex;
          align-items:center;
          gap:8px;
          padding:6px 8px;
          background:#fff;
          border:1px solid #ededed;
          border-radius:4px;
        }

        .tab-toggle-btn {
          display:flex;
          align-items:center;
          justify-content:center;
          padding:6px;
          border:none;
          border-radius:3px;
          background:transparent;
          cursor:pointer;
        }

        .tab-toggle-btn[data-active="true"] {
          background:#e8e3f8;
        }

        .tab-toggle-icon img {
          width:20px;
          height:20px;
          object-fit:contain;
          display:block;
        }
      `}</style>

      <div className={`tab-toggle-root ${className}`}>
        {items.map(({ id, activeIcon, inactiveIcon }) => {
          const isActive = active === id;

          return (
            <button
              key={id}
              className="tab-toggle-btn"
              data-active={isActive}
              onClick={() => handleSelect(id)}
            >
              <span className="tab-toggle-icon">
                <img
                  src={isActive ? activeIcon : inactiveIcon}
                  alt=""
                />
              </span>
            </button>
          );
        })}
      </div>
    </>
  );
}